<template>
  <div>
    <CRow>
      <CCol md="12">
        <ProfileDataData />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ProfileDataData from "./ProfileDataData";
export default {
  name: "ProfileData",
  components: {
    ProfileDataData,
  },
};
</script>
